import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Business {
  id: string; // Access record ID
  merchant_id: string; // Actual merchant/business ID
  name: string;
  gst_number: string;
  city?: string;
  state?: string;
  access_granted_at?: string;
}

interface AuditorState {
  currentBusiness: Business | null;
  accessibleBusinesses: Business[];
  isAuditor: boolean;

  // Actions
  setCurrentBusiness: (business: Business | null) => void;
  setAccessibleBusinesses: (businesses: Business[]) => void;
  switchBusiness: (businessId: string) => void;
  setIsAuditor: (isAuditor: boolean) => void;
  clearAuditorData: () => void;
  getCurrentBusinessId: () => string | null;
}

export const useAuditorStore = create<AuditorState>()(
  persist(
    (set, get) => ({
      currentBusiness: null,
      accessibleBusinesses: [],
      isAuditor: false,

      setCurrentBusiness: (business) => {
        console.log('Setting current business:', business);
        set({ currentBusiness: business });
      },

      setAccessibleBusinesses: (businesses) => {
        console.log('Setting accessible businesses:', businesses);
        set({ accessibleBusinesses: businesses });
      },

      switchBusiness: (businessId) => {
        const business = get().accessibleBusinesses.find(b => b.merchant_id === businessId);
        if (business) {
          console.log('Switching to business:', business);
          set({ currentBusiness: business });
        }
      },

      setIsAuditor: (isAuditor) => {
        set({ isAuditor });
      },

      clearAuditorData: () => {
        set({
          currentBusiness: null,
          accessibleBusinesses: [],
          isAuditor: false,
        });
      },

      getCurrentBusinessId: () => {
        return get().currentBusiness?.merchant_id || null;
      },
    }),
    {
      name: 'auditor-storage',
      version: 1,
      migrate: (persistedState: any, version: number) => {
        // If old version without merchant_id, clear the state
        if (version === 0) {
          console.log('Migrating auditor storage from v0 to v1 - clearing old data');
          return {
            currentBusiness: null,
            accessibleBusinesses: [],
            isAuditor: false,
          };
        }
        return persistedState;
      },
    }
  )
);
